export const getFileNameFromUrl = (url) => {
  if (url) {
    return url.split('/').pop()
  }
  return ``;
};
